import { ButtonProps } from '@carvana/showroom-forms/Button/Base/Button';
import classNames from 'classnames';
import React from 'react';
import { PrimaryButton } from '@/common/Button';
import LoadingEllipsis from '@/common/LoadingEllipsis';
import CtaType from '~/constants/ctaType';
import { useButtonHandler } from '~/hooks/vdp/cta';
import useCtaButtonState from '~/hooks/vdp/selectors/useCtaButtonState';

const dummyFunction = () => {};

type OwnProps<T> = {
  Button?: React.ComponentType<any>;
  className?: string;
  'data-analytics-id': string;
  'data-qa'?: string;
  getStartedText?: string;
  onClick?: () => void;
} & T;

function CtaButton<T = ButtonProps>({
  Button = PrimaryButton,
  className = '',
  'data-analytics-id': analyticsId,
  'data-qa': qaId,
  getStartedText = 'Get Started',
  onClick = dummyFunction,
  ...rest
}: OwnProps<T>) {
  const handleOnClick = useButtonHandler(onClick) ?? dummyFunction;
  const { isDisabled, type } = useCtaButtonState();

  const ctaTypes: Record<CtaType, React.ReactNode> = {
    [CtaType.ContinuePurchase]: 'Continue Purchase',
    [CtaType.Default]: getStartedText,
    [CtaType.GetStarted]: getStartedText,
    [CtaType.Loader]: <LoadingEllipsis size={9} white />,
    [CtaType.NotifyMe]: 'Notify Me',
    [CtaType.Reservable]: 'Pre-Order Now',
    [CtaType.Reservation]: null
  };

  return CtaType[type] === CtaType.Reservation ? null : (
    <Button
      className={classNames(className, {
        '!bg-green-2 hover:!bg-green-3': !isDisabled
      })}
      disabled={isDisabled}
      onClick={handleOnClick}
      data-analytics-id={analyticsId}
      data-qa={qaId}
      {...rest}
    >
      {ctaTypes[type]}
    </Button>
  );
}

export default CtaButton;
